export const TITLE = 'Working with leaders and newbies across the Geospatial field';
export const CONTENT =
  'We work with a variety of clients to solve complex challenges related to geospatial data. Many of those come with optimizing data for various uses as well as creating workflows around data for integration with business use cases.';
